export const data7_6_1_default = [{
    comments: '',
}]


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-6/data7_6_1.js